<template>
    <div class="verpflegung">
        <el-card class="box-card">
            <template #header>
                <div class="logo-header">
                    <span class="ta-left">Deutsches Rotes Kreuz<br>Hurricane Festival 2026<br>Sanitäts- und Rettungsdienst</span>
                    <div>
                        <img src="../assets/logo-drk.svg" class="logo-image"/>
                        <br>
                        <el-button type="danger" @click="logout">Abmelden</el-button>
                        <br>
                        <router-link v-if="isAdmin" to="/admin/dashboard">
                            <el-button type="primary" style="margin-top: 5px;">Zurück zum Admin-Dashboard</el-button>
                        </router-link>
                        <router-link v-else to="/unitdashboard">
                            <el-button type="primary" style="margin-top: 5px;">Zurück zum Dashboard</el-button>
                        </router-link>
                        <br>
                        <password/>
                    </div>
                </div>
            </template>
            <el-card>
                <template #header>
                    <div class="card-header">
                        <h2>Verpflegung — {{ selectedLabel }}</h2>
                        <div style="display: flex; gap: 10px; align-items: center;">
                            <el-select v-model="selectedUnit" placeholder="Einheit" style="width: 280px;">
                                <el-option label="Alle Einheiten (Gesamt)" value="__all__" />
                                <el-option
                                    v-for="u in unitNames"
                                    :key="u"
                                    :label="u"
                                    :value="u"
                                />
                            </el-select>
                            <el-button type="success" @click="exportCsv">CSV Export</el-button>
                        </div>
                    </div>
                </template>
                <el-row :gutter="12">
                    <el-col :span="12" v-for="day in mealDays" :key="day.key">
                        <el-card class="day-card">
                            <template #header>
                                <h3>{{ day.label }}</h3>
                            </template>
                            <el-table :data="rowsFor(day.key)" stripe size="small" style="width: 100%">
                                <el-table-column prop="meal" label="Mahlzeit" width="120"/>
                                <el-table-column prop="normal" label="Normal" align="right"/>
                                <el-table-column prop="glutenfrei" label="Glutenfrei" align="right"/>
                                <el-table-column prop="vegan" label="Vegan" align="right"/>
                                <el-table-column prop="vegu" label="Vegan/Gluten" align="right"/>
                                <el-table-column prop="total" label="Gesamt" align="right">
                                    <template #default="{ row }"><strong>{{ row.total }}</strong></template>
                                </el-table-column>
                            </el-table>
                        </el-card>
                    </el-col>
                </el-row>
            </el-card>
        </el-card>
    </div>
</template>

<script>
import Axios from "axios";
import Password from "@/components/password.vue";
import { ElNotification } from "element-plus";

export default {
    name: "Verpflegung",
    components: { Password },
    data() {
        return {
            totalSummary: {},
            unitSummaries: {},
            selectedUnit: '__all__',
            mealDays: [
                { key: 'do', label: 'Donnerstag' },
                { key: 'fr', label: 'Freitag' },
                { key: 'sa', label: 'Samstag' },
                { key: 'so', label: 'Sonntag' },
                { key: 'mo', label: 'Montag' }
            ],
            mealCourses: [
                { key: 'br', label: 'Frühstück' },
                { key: 'lu', label: 'Mittag' },
                { key: 'di', label: 'Abend' },
                { key: 'de', label: 'Nacht' }
            ]
        };
    },
    computed: {
        isAdmin() {
            return this.$store.getters.getRole === 99;
        },
        unitNames() {
            return Object.keys(this.unitSummaries);
        },
        activeSummary() {
            return this.selectedUnit === '__all__'
                ? this.totalSummary
                : (this.unitSummaries[this.selectedUnit] || {});
        },
        selectedLabel() {
            return this.selectedUnit === '__all__' ? 'Gesamt' : this.selectedUnit;
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('logout');
            this.$router.push('/');
        },
        async loadMealSummary() {
            try {
                const response = await Axios.get(`${process.env.VUE_APP_API_URL}/api/personalmealsummary`);
                const data = response.data.data || {};
                this.totalSummary = data.total || {};
                this.unitSummaries = data.units || {};
            } catch (error) {
                console.log('mealsummary:', error);
                ElNotification({
                    title: 'Fehler',
                    message: 'Verpflegungsdaten konnten nicht geladen werden',
                    type: 'error'
                });
            }
        },
        rowsFor(dayKey) {
            return this.mealCourses.map(course => {
                const cell = this.activeSummary[dayKey + course.key] || {};
                return {
                    meal: course.label,
                    normal: cell.normal || 0,
                    glutenfrei: cell.glutenfrei || 0,
                    vegan: cell.vegan || 0,
                    vegu: cell.vegu || 0,
                    total: cell.total || 0
                };
            });
        },
        exportCsv() {
            const headers = ['Tag', 'Mahlzeit', 'Normal', 'Glutenfrei', 'Vegan', 'Vegan/Glutenfrei', 'Gesamt'];
            const lines = [`Einheit: ${this.selectedLabel}`, headers.join(';')];
            this.mealDays.forEach(day => {
                this.rowsFor(day.key).forEach(row => {
                    lines.push([
                        day.label, row.meal, row.normal, row.glutenfrei,
                        row.vegan, row.vegu, row.total
                    ].join(';'));
                });
            });
            const blob = new Blob(['﻿' + lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            const date = new Date().toISOString().slice(0, 10);
            const slug = this.selectedUnit === '__all__'
                ? 'gesamt'
                : this.selectedUnit.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
            link.href = url;
            link.download = `verpflegung-${slug}-${date}.csv`;
            link.click();
            URL.revokeObjectURL(url);
        }
    },
    async created() {
        if (!this.$store.getters.isLoggedIn) {
            this.$router.push('/');
            return;
        }
        const role = this.$store.getters.getRole;
        if (role !== 2 && role !== 99) {
            this.$router.push('/unitdashboard');
            return;
        }
        await this.loadMealSummary();
    }
};
</script>

<style scoped>
.verpflegung {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.box-card {
    max-width: 1100px;
    flex: auto;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.day-card {
    margin-bottom: 12px;
}

.day-card h3 {
    margin: 0;
    color: #333;
}

.logo-image {
    width: 200px;
    display: flex;
}

.logo-header {
    justify-content: space-between;
    display: flex;
}

.ta-left {
    text-align: left;
}
</style>
